
import store from "../store";
import constants from "../config/constants";
import { serviceDietitianDashboardUpcomingSessions } from "../services/DietitianDashboard.service";

export const FETCH_INIT = 'FETCH_INIT_UPCOMING_SESSIONS';
export const FETCHED = 'FETCHED_UPCOMING_SESSIONS';
export const FETCHED_FAIL = 'FETCHED_FAIL_UPCOMING_SESSIONS';
export const FETCHED_FILTER = 'FETCHED_FILTER_UPCOMING_SESSIONS';
export const FETCH_NEXT = 'FETCH_NEXT_UPCOMING_SESSIONS';
export const FILTER = 'FILTER_UPCOMING_SESSIONS';
export const RESET_FILTER = 'RESET_FILTER_UPCOMING_SESSIONS';
export const SET_SORTING = 'SET_SORTING_UPCOMING_SESSIONS';
export const SET_FILTER = 'SET_FILTER_UPCOMING_SESSIONS';
export const SET_PAGE = 'SET_PAGE_UPCOMING_SESSIONS';
export const CHANGE_PAGE = 'CHANGE_PAGE_UPCOMING_SESSIONS';
export const CHANGE_STATUS = 'CHANGE_STATE_UPCOMING_SESSIONS';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_UPCOMING_SESSIONS';
export const SET_ROW_SIZE = 'SET_ROW_SIZE_UPCOMING_SESSIONS';

export const CREATE_DATA = 'CREATE_UPCOMING_SESSIONS';
export const UPDATE_DATA = 'UPDATE_UPCOMING_SESSIONS';
export const DELETE_ITEM = 'DELETE_UPCOMING_SESSIONS';
export const CLEAN_UPCOMING_SESSIONS = 'CLEAN_UPCOMING_SESSIONS';
export const RESET_TABLE_DATA = 'RESET_TABLE_DATA_SESSIONS';

export function actionFetchUpcomingSessions(pageId = 0, sorting = {}, filter = {}, shouldReset = false) {
    const stateData = store.getState().dietitian_upcoming_sessions;
    const rowSize = stateData.rowsPerPage || 10;
    const finalFilter = { ...filter };

    const request = serviceDietitianDashboardUpcomingSessions({
        pageId: pageId, // 0-based pageId
        row: rowSize,
        order: sorting.order,
        sort_by: sorting.row,
        ...finalFilter,
    });

    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 0,
            });
        }
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data?.data, page: pageId } });
                dispatch({ type: SET_SERVER_PAGE, payload: pageId });
                if (pageId === 0) {
                    dispatch({ type: CHANGE_PAGE, payload: 0 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}

export function actionChangePageSessions(page) {
    return (dispatch) => {
        dispatch({ type: CHANGE_PAGE, payload: page });
    };
}

export function actionFilterSessions(value) {
    const request = null;
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: FILTER, payload: data });
            dispatch({ type: FETCHED, payload: null });
        });
    };
}

export function actionChangeStatusSessions(id, status) {
    return (dispatch) => {
        dispatch({ type: CHANGE_STATUS, payload: { id, status } });
    };
}

export function actionResetFilterSessions() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionCleanUpcomingSessions() {
    return {
        type: CLEAN_UPCOMING_SESSIONS,
        payload: null,
    };
}

export function actionSetRowSize(value) {
    return {
        type: SET_ROW_SIZE,
        payload: value,
    };
}

export function actionResetSessionTable() {
    return { type: RESET_TABLE_DATA, payload: null };
}

export function actionSetPageSessions(page, extraPayload) {
    const stateData = store.getState().dietitian_upcoming_sessions;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const filter = stateData.filter;
    const serverPage = stateData.serverPage || 0;
    const rowsPerPage = stateData.rowsPerPage || 10;

    // Check if we need to fetch more data
    if (totalLength <= ((page + 1) * rowsPerPage)) {
        const nextPage = serverPage + 1;
        const payload = {
            ...extraPayload,
            pageId: nextPage,
            row: rowsPerPage,
        };
        delete payload.index;
        store.dispatch(actionFetchUpcomingSessions(nextPage, sortingData, { ...filter, ...payload }));
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}